import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// SVG Icons (can remain as they are or be imported)
const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
  </svg>
);
const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);
const PinterestIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.627 0-12 5.372-12 12 0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146 1.124.347 2.317.535 3.554.535 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
  </svg>
);
const TwitterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
  </svg>
);
const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const TrustSecureIcon = () => (
  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
  </svg>
);
const TrustTruckIcon = () => (
  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.086H19.5M6.75 18.75v-1.125c0-.621.504-1.125 1.125-1.125M6.75 18.75v-1.125A1.125 1.125 0 019 15.375m-3.75 0V18m0-2.625h18M15.75 18.75v-1.125c0-.621.504-1.125 1.125-1.125" />
  </svg>
);
const TrustGridIcon = () => (
  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
  </svg>
);
const TrustHeadsetIcon = () => (
  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" />
  </svg>
);

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { to: "/", labelKey: "nav.home", defaultLabel: "Home" },
    { to: "/products", labelKey: "nav.products", defaultLabel: "Products" },
    { to: "/configurator", labelKey: "nav.configurator", defaultLabel: "Design Tool" },
    { to: "/faq", labelKey: "nav.faq", defaultLabel: "FAQ" },
    { to: "/contact", labelKey: "nav.contact", defaultLabel: "Contact" },
    { to: "/orders/search", labelKey: "nav.trackOrder", defaultLabel: "Track Order" },
  ];

  const policyLinks = [
    { to: "/about", labelKey: "footer.links.about", default: "Hakkımızda" },
    { to: "/privacy-policy", labelKey: "footer.links.privacy", default: "Gizlilik Politikası" },
    { to: "/distance-sales-agreement", labelKey: "footer.links.distanceSales", default: "Mesafeli Satış Sözleşmesi" },
    { to: "/warranty-return", labelKey: "footer.links.warrantyReturn", default: "Garanti ve İade Koşulları" },
    { to: "/membership-agreement", labelKey: "footer.links.membershipAgreement", default: "Üyelik Sözleşmesi" },
  ];

  const socialLinks = [
    // { href: "#", label: "Facebook", icon: <FacebookIcon /> },
    { href: "https://www.instagram.com/felicitafragrances/", label: "Instagram", icon: <InstagramIcon /> },
    { href: "https://x.com/Felicitafrag", label: "Twitter", icon: <TwitterIcon /> },
    // { href: "#", label: "Pinterest", icon: <PinterestIcon /> },
  ];

  const trustBadges = [
    { Icon: TrustSecureIcon, labelKey: 'trust.securePayment' },
    { Icon: TrustTruckIcon, labelKey: 'trust.fastDelivery' },
    { Icon: TrustGridIcon, labelKey: 'trust.wideProductRange' },
    { Icon: TrustHeadsetIcon, labelKey: 'trust.support247' },
  ];

  return (
    <footer className="relative">
      {/* Background with glassmorphic effect */}
      <div className="absolute  "></div>

      {/* Main content */}
      <div className="relative z-10">
        <div className="border-b border-gray-200/90 bg-gray-50/40">
          <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
            <ul
              className="grid grid-cols-2 gap-5 sm:gap-6 lg:grid-cols-4 lg:gap-8 max-w-5xl lg:max-w-none mx-auto"
              aria-label={t('footer.trustBadgesAria')}
            >
              {trustBadges.map(({ Icon, labelKey }) => (
                <li key={labelKey} className="flex flex-col items-center text-center gap-2 sm:gap-2.5">
                  <div className="flex h-11 w-11 sm:h-12 sm:w-12 items-center justify-center rounded-full border border-gray-200 bg-white/80 text-gray-800 shadow-sm">
                    <Icon />
                  </div>
                  <span className="text-[11px] sm:text-xs font-medium text-gray-700 leading-snug tracking-tight max-w-[10rem]">
                    {t(labelKey)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-6 sm:gap-8 xl:gap-10">

            {/* Brand and Info - Wider on large screens */}
            <div className="md:col-span-2 lg:col-span-5">
              <Link to="/" className="inline-block mb-3 sm:mb-5">
                <div className="flex items-center">
                  <img
                    src={`/logo2.png`}
                    alt={t('general.brand', 'Felicita Fragrances')}
                    className="h-8 sm:h-10 w-auto"
                  />
                </div>
              </Link>
              <p className="text-xs sm:text-sm leading-relaxed mb-4 sm:mb-6">
                {t('footer.about', 'Premium perfume bottles crafted with elegance and precision. Our designs enhance the beauty of your fragrances while providing functionality.')}
              </p>
              <div className="flex space-x-3 sm:space-x-4">
                {socialLinks.map(social => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="scale-75 sm:scale-100">
                      {social.icon}
                    </div>
                  </a>
                ))}
              </div>

              {/* Payment Methods */}
              <div className="mt-6 sm:mt-8">
                <h4 className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3">
                  {t('footer.paymentMethods', 'Payment Methods')}
                </h4>
                <img
                  src="/subbrands.png"
                  alt={t('footer.paymentMethodsAlt', 'Accepted payment methods')}
                  className="h-24 sm:h-32 w-auto"
                  onError={(event) => {
                    event.currentTarget.src = '/logo_band_white@3x.png';
                  }}
                />
              </div>
            </div>

            {/* Spacer for layout on large screens */}
            <div className="lg:col-span-1"></div>

            {/* Quick Links */}
            <div className="lg:col-span-3">
              <div className="p-4 sm:p-6 h-full">
                <h3 className="text-sm sm:text-base font-medium mb-3 sm:mb-4">
                  {t('footer.quickLinks', 'Quick Links')}
                </h3>
                <ul className="space-y-2 sm:space-y-3">
                  {footerLinks.map(link => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-xs sm:text-sm text-gray-700 hover:text-gray-900 transition-colors"
                      >
                        {t(link.labelKey, link.defaultLabel)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="lg:col-span-3">
              <div className="p-4 sm:p-6 h-full">
                <h3 className="text-sm sm:text-base font-medium mb-3 sm:mb-4">
                  {t('contact.info.title', 'Contact Information')}
                </h3>
                <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                  <li className="flex items-center">
                    <span className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white/10 rounded-full mr-2 sm:mr-3 flex-shrink-0 text-gray-600">
                      <div className="scale-75 sm:scale-100">
                        <PhoneIcon />
                      </div>
                    </span>
                    <a
                      href={`tel:${t('contact.info.phoneValue')}`}
                      className="text-gray-700 hover:text-gray-900 transition-colors"
                    >
                      {t('contact.info.phoneValue', '+90 212 555 1234')}
                    </a>
                  </li>
                  <li className="flex items-center">
                    <span className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white/10 rounded-full mr-2 sm:mr-3 flex-shrink-0 text-gray-600">
                      <div className="scale-75 sm:scale-100">
                        <EmailIcon />
                      </div>
                    </span>
                    <a
                      href={`mailto:${t('contact.info.emailValue')}`}
                      className="text-gray-700 hover:text-gray-900 transition-colors break-all"
                    >
                      {t('contact.info.emailValue', 'info@felicitafragrances.com')}
                    </a>
                  </li>
                  <li className="flex items-start pt-1">
                    <span className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center bg-white/10 rounded-full mr-2 sm:mr-3 flex-shrink-0 text-gray-600">
                      <div className="scale-75 sm:scale-100">

                      </div>
                    </span>

                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar - Centered in one line */}
        <div className="mx-4 sm:mx-6 mb-4 sm:mb-6 p-4 sm:p-6">
          <div className="container mx-auto">
            <div className="flex flex-col md:flex-row items-center justify-center text-center space-y-2 sm:space-y-3 md:space-y-0">
              <div className="flex flex-col md:flex-row items-center justify-center space-y-2 sm:space-y-3 md:space-y-0 md:space-x-8">
                <p className="text-xs text-gray-600">
                  © {currentYear} {t('general.brand', 'Felicita Fragrances')}. {t('footer.copyright', 'All rights reserved.')}
                </p>
                <div className="flex flex-wrap justify-center gap-3 sm:gap-6">
                  {policyLinks.map(link => (
                    <Link
                      key={link.labelKey}
                      to={link.to}
                      className="text-xs text-gray-600 hover:text-gray-900 hover:underline transition-colors"
                    >
                      {t(link.labelKey, link.default)}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;